import cx from 'classnames'
import IntlMessage from '../../common/intl/intl_message'
import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'

function MenuItemContent ({ pageId, id, icon, title, isBeta, ...props }) {
  const active = pageId === id

  return (
    <button
      className={cx('sidebar__menu-item', {
        'sidebar__menu-item--active': active
      })}
      {...props}
    >
      <div className='sidebar__menu-item__icon'>
        {cloneElement(icon, { style: { height: '100%' } })}
      </div>
      <span className='sidebar__menu-item__title'>
        <IntlMessage ident={title} />
        {isBeta && <span className='sidebar__menu-item__beta'>Beta</span>}
      </span>
    </button>
  )
}

MenuItemContent.propTypes = {
  pageId: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.element,
  title: PropTypes.string,
  isBeta: PropTypes.bool
}

export { MenuItemContent }
